module.exports = __webpack_public_path__ + "static/media/jrforman.9c0e05e4.jpg";